"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModalsHost = void 0;
const React = __importStar(require("react"));
const components_1 = require("@smapiot/components");
const ModalsHost = ({ open, close, children }) => {
    (0, components_1.useModal)(open);
    const nodes = React.Children.toArray(children);
    const blocked = nodes.some((child) => {
        var _a;
        return React.isValidElement(child) && ((_a = child.props.options) === null || _a === void 0 ? void 0 : _a.block);
    });
    const onClose = () => {
        if (!blocked) {
            close();
        }
    };
    const keydown = (e) => {
        if (e.keyCode === 27 || e.code === 'Escape') {
            e.preventDefault();
            e.stopPropagation();
            onClose();
        }
    };
    React.useLayoutEffect(() => {
        if (nodes.length > 0) {
            const dialog = document.querySelector('.modal .modal-dialog');
            if (dialog) {
                dialog.setAttribute('tabindex', '0');
                setTimeout(() => dialog.focus(), 0);
            }
        }
    }, [nodes.length]);
    return (React.createElement("div", { className: "modal", onClick: onClose, onKeyDown: keydown, tabIndex: 0 }, children));
};
exports.ModalsHost = ModalsHost;
